import Fingerprint2 from "fingerprintjs2";
const uuidv4 = require("uuid/v4");
import axios from "axios";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";

let storage = (function() {
  let uid = uuidv4();
  let storage;
  let result;
  try {
    (storage = window.localStorage).setItem(uid, uid);
    result = storage.getItem(uid) === uid;
    storage.removeItem(uid);
    return result && storage;
  } catch (exception) {
    return false;
  }
})();

export default class Person {
  constructor(media, share, eventBus) {
    this.viewer = {};
    this.session = {};
    this.currentInterval = {};
    this.media = media;
    this.share = share;
    this.eventBus = eventBus;

    this.currentTime = 0;
    this.lastTime = 0;

    this.isPlayed = false;

    this.initViewer().then(() => {
      this.initSession();
    });

    eventBus.$on("video.play", () => {
      if (!this.isPlayed) {
        this.createSessionInterval(0, 1);
      }
    });

    eventBus.$on("video.setCurrentTime", ({ time }) => {
      this.currentTime = time;
      this.debouncedCreateSessionInterval(
        Math.round(time),
        Math.round(time) + 1
      );
    });

    eventBus.$on("video.timeupdate", ({ currentTime }) => {
      this.currentTime = currentTime;
      this.throttledUpdateCurrentSessionInterval();
    });
  }

  getFingerprintViewer() {
    let options = {
      excludes: {
        userAgent: true,
        adBlock: true,
        enumerateDevices: true,
        pixelRatio: true,
        doNotTrack: true,
        fontsFlash: true
      }
    };

    return Fingerprint2.getPromise(options).then(components => {
      let values = components.map(function(component) {
        return component.value;
      });
      return Fingerprint2.x64hash128(values.join(""), 31);
    });
  }

  initViewer() {
    axios.post(`/api/public/statistics/medias/impressions/`, {
      origin: document.referrer || "-",
      media_id: this.media.uid
    });

    if (storage) {
      const viewerId = storage.getItem("viewer-uid") || "";
      if (viewerId) {
        return axios
          .get(`/api/public/statistics/medias/viewers/${viewerId}/`)
          .then(res => {
            this.viewer = res.data;
          })
          .catch(() => {
            storage.removeItem("viewer-uid");
            return this.initViewer();
          });
      } else {
        return this.getFingerprintViewer().then(fingerprint => {
          if (fingerprint) {
            return axios
              .post("/api/public/statistics/medias/viewers/fingerprint/", {
                fingerprint: fingerprint
              })
              .then(res => {
                storage.setItem("viewer-uid", res.data.uid);
                this.viewer = res.data;
              });
          }
        });
      }
    }

    return axios
      .post("/api/public/statistics/medias/viewers/fingerprint/", {
        fingerprint: "private-" + uuidv4()
      })
      .then(res => {
        this.viewer = res.data;
      });
  }

  initSession() {
    return axios
      .post("/api/public/statistics/medias/sessions/", {
        viewer_id: this.viewer.uid,
        media_id: this.media.uid,
        share_id: this.share.uid
      })
      .then(res => {
        this.session = res.data;
      });
  }

  createSessionInterval(start, end) {
    this.currentInterval = {
      uid: uuidv4(),
      start,
      end,
      session_id: this.session.uid
    };

    axios
      .post(
        `/api/public/statistics/medias/sessions/intervals/`,
        this.currentInterval
      )
      .then(res => (this.currentInterval = res.data));
  }

  debouncedCreateSessionInterval = debounce(function(start, end) {
    this.createSessionInterval(start, end);
  }, 200);

  throttledUpdateCurrentSessionInterval = throttle(
    function() {
      this.updateCurrentSessionInterval();
    },
    5000,
    { leading: false }
  );

  updateCurrentSessionInterval() {
    if (Math.round(this.$video.currentTime) > this.currentInterval.start) {
      axios.patch(
        `/api/public/statistics/medias/sessions/intervals/${
          this.currentInterval.uid
        }/`,
        {
          end: Math.round(this.$video.currentTime)
        }
      );
    }
  }
}
